import * as algoliasearch from "algoliasearch";

export default defineNuxtPlugin(() => {
  //   console.log("NUXT_PUBLIC_ALGOLIA_APP_ID",NUXT_PUBLIC_ALGOLIA_APP_ID);
  const { public: publicConfig } = useRuntimeConfig();
  const client = algoliasearch.algoliasearch(
    publicConfig.NUXT_PUBLIC_ALGOLIA_APP_ID!,
    publicConfig.NUXT_PUBLIC_ALGOLIA_SEARCH_KEY!
  );

  return {
    provide: {
      algolia: client,
    },
  };
});
